<template>
    <v-container fluid>
      <div class="text-h6 white--text d-md-none" style="margin-top: 10px;">Agora você pode selecionar<br />sua forma de pagamento</div>
      <div class="text-h6 black--text d-none d-md-block" style="margin-top: 10px;">Agora você pode selecionar<br />sua forma de pagamento</div>
      <div class="text-caption black--text d-none d-md-block" style="margin-top: 10px;">Abaixo você escolhe em qual forma de pagamento deseja pagar</div>
      <v-row>
        <v-col class="col-12 col-md-8">
          <v-row dense>
            <v-col class="col-6 col-md-4">
              <v-card class="mx-auto card-button pt-4" block  @click="checkPedido(5)">
                <v-img src="/img/pix.jpg" style="width: 140px" class="mx-auto" />
              </v-card>
            </v-col>
            <v-col class="col-6 col-md-4">
              <v-card class="mx-auto card-button" block @click="checkPedido(1)">
                <v-spacer class="pa-3"></v-spacer>
                <v-img src="/img/cartao-credito.png" style="width: 120px" class="mx-auto" />
                <div class="text-center">Cartão de Crédito</div>
              </v-card>
            </v-col>
            <!-- <v-col class="col-6 col-md-4">
              <v-card class="mx-auto card-button" block @click="checkPedido(3)">
                <v-img src="/img/banricompras.png" style="width: 120px" class="mx-auto" />
                <div class="text-center">Banricompras à Vista</div>
              </v-card>
            </v-col>
            <v-col class="col-6 col-md-4">
              <v-card class="mx-auto card-button" block @click="checkPedido(4)">
                <v-img src="/img/banricompras.png" style="width: 120px" class="mx-auto" />
                <div class="text-center">Banricompras 30 dias</div>
              </v-card>
            </v-col> -->
            <!-- <v-col class="col-6 col-md-4">
              <v-card class="mx-auto card-button" block @click="checkPedido(2)">
                <v-spacer class="pa-3"></v-spacer>
                <v-img src="/img/cartao-credito.png" style="width: 120px" class="mx-auto" />
                <div class="text-center">Cartão de Débito</div>
              </v-card>
            </v-col> -->
          </v-row>
        </v-col>
      </v-row>
      Qualquer dúvida ou problema com pagamento por favor nos informe via whatsapp pelo número <a href="https://wa.me/555199926208">(51) 99992-6208</a> com Edgar, (basta clicar no telefone para abrir o whatsapp)
    </v-container>
</template>
<style scoped>
.card-button {
  background-color: white;
  width: 100%;
  height: 200px !important;
}
</style>
<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState(['logadoVisitante', 'dialogLogin']),
    ...mapGetters(['totalCarrinho'])
  },
  methods: {
    ...mapActions(['selecionaFormaPagamento']),
    checkPedido: function (id) {
      this.selecionaFormaPagamento(id).then(() => {
        switch (id) {
          case 1:
            this.$router.push('/pagamento/credito')
            break
          case 2:
            this.$router.push('/pagamento/debito')
            break
          case 3:
            this.$router.push('/pagamento/banricompras')
            break
          case 4:
            this.$router.push('/pagamento/banricompras')
            break
          case 5:
            this.$router.push('/pagamento/pix')
            break
        }
      })
    }
  }
}
</script>
